import React from "react";
import { Select } from "@windmill/react-ui";

const SelectTripTypeThree = ({ register, name, label, readOnly, onChange, defaultValue, required}) => {
  
  return (
    <>
      <Select
        className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
        name={name}
        {...register(`${name}`, {
          ...(required && { required: `${label} is required!` }),
        })}
        disabled={readOnly}
        value={defaultValue} 
        onChange={onChange}
      >
        <option value="" defaultValue hidden>Select type</option>
       
        <option value="Hourly Rental">Hourly Rental</option>
        <option value="Outstation">Outstation</option>
        <option value="Holiday Package">Holiday Package</option>
      </Select>
    </>
  );
};

export default SelectTripTypeThree;
